<template>
  <v-row no-gutters>
    <v-col v-if="selectedSection.logo" cols="6" class="pb-5 _pr-">
      <TextField 
        v-model="selectedSection.logo_height"
        label="Altura"
        type="number"
        :minValueForNumber="20"
      />
    </v-col>
    <v-col v-if="selectedSection.logo && showField('alignment')" cols="6" class="pb-5 _pl-">
      <FormAlignment v-model="selectedSection" keyValue="logo_alignment" label="Alinhamento" />
    </v-col>

    <v-col cols="12">
      <UploadImage v-model="section" keyValue="logo"/>
    </v-col>
  </v-row>
</template>

<script>
// Used only for types: cover and menu.
import UploadImage from '../../../_v2/utils/UploadImage.vue'
import TextField from '../../../_v2/ui/TextField.vue'
import FormAlignment from '../../../_v2/utils/FormAlignment.vue'

export default {
  name: 'Logo',
  components: { UploadImage, TextField, FormAlignment },
  props: {
    selectedSection: {type: Object, required: true},
    sectionType: {type: String, required: true},
    hide: {type: Array, default: () => ([])} // ['alignment'] 
  },

  computed: {
    section: {
      get () { return this.selectedSection },
      set (v) { 
        this.$emit('update', v) 
      }
    }
  },

  methods: {
    showField (type) {
      return !this.hide.includes(type)
    }    
  }    
}
</script>